import React, { useEffect, useState } from 'react';
import { Modal, Input } from 'antd';

const COLORS = ['#4ADE80', '#60A5FA', '#F87171', '#FBBF24', '#A78BFA', '#34D399', '#FB923C', '#E879F9'];

interface Props {
    open: boolean;
    initialName?: string;
    initialColor?: string;
    title: string;
    onConfirm: (name: string, color: string) => Promise<void>;
    onClose: () => void;
}

const FolderModal: React.FC<Props> = ({ open, initialName = '', initialColor = COLORS[0], title, onConfirm, onClose }) => {
    const [name, setName] = useState(initialName);
    const [color, setColor] = useState(initialColor);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) { setName(initialName); setColor(initialColor); }
    }, [open, initialName, initialColor]);

    const handleOk = async () => {
        if (!name.trim()) return;
        setLoading(true);
        try { await onConfirm(name.trim(), color); }
        finally { setLoading(false); }
    };

    return (
        <Modal
            title={title}
            open={open}
            onCancel={onClose}
            onOk={handleOk}
            okText="Lưu"
            cancelText="Hủy"
            okButtonProps={{ disabled: !name.trim(), loading }}
            width={400}
        >
            <div className="mt-3 space-y-4">
                <div>
                    <label className="mb-1 block text-sm font-medium text-text-secondary">Tên thư mục</label>
                    <Input
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="Nhập tên thư mục"
                        onPressEnter={handleOk}
                        autoFocus
                    />
                </div>
                <div>
                    <label className="mb-2 block text-sm font-medium text-text-secondary">Màu sắc</label>
                    <div className="flex flex-wrap gap-2">
                        {COLORS.map(c => (
                            <button
                                key={c}
                                onClick={() => setColor(c)}
                                className={`h-7 w-7 rounded-full transition-transform hover:scale-110 ${color === c ? 'ring-2 ring-offset-2 ring-primary scale-110' : ''}`}
                                style={{ backgroundColor: c }}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default FolderModal;
